import React from "react";
import * as fn from "../../../helper/uiFunctions";

//enableSelect = 1 means single selection, 2 means multiple selection
const useRowSelector = (enableSelect, onSelectedRowsChange) => {

    const [selectedRows, setSelectedRows] = React.useState([]);
    const [availablePageRows, setAvailablePageRows] = React.useState([]);
    const [selectAll, setSelecteAll] = React.useState(0);

    const isEnableSelect = () => {
        return enableSelect;
    }

    const isSelectAll = () => {
        return selectAll === 1;

        // //if this loop is inefficient then comment this section and instead return the value from state
        // this loop is not working because isSelectAll is called before the SarasRowSelector buils the available rows list
        // let selectCount = 0;
        
        // let rowId;
        // let rowIndex;

        // for (var i = 0; i < availablePageRows.length; i++) {
        //     rowId = availablePageRows[i];
        //     rowIndex = selectedRows.indexOf(rowId);

        //     //skip the loop if even one row is not added
        //     if(rowIndex == -1) break;
        //     else selectCount++;
        // }

        // return (availablePageRows.length > 0 && selectCount == availablePageRows.length);
    }

    //reset the available page rows on every page change
    //call this whenever search result changes or page changes
    //combination of onPageChange and onTrackAvailableRows is important for SelectAll to work
    const onPageChange = () => {
        setAvailablePageRows([]);

        //ensure the select flag is reset aswell
        setSelecteAll(0);
    }

    //after page changes, SarasRowSelector will trigger this call to track the available rows.
    const onTrackAvailableRows = (rowId) => {
        let index = availablePageRows.indexOf(rowId);

        if(index === -1) availablePageRows.push(rowId);
    }

    //add or remove all available page rows in the selected rows
    //do not add / remove all selected rows (eg: i may select 2 rows from page 1 and all rows from page 2)
    //select all click should only operate on the rows of the current page that are in availablePageRows
    const onSelectAllClick = (isAllSelected) => {
        setSelecteAll(isAllSelected ? 1 : 0);
        let rowId;
        let rowIndex;

        //create a clone to operate on
        let rowList = [...selectedRows];

        for (var i = 0; i < availablePageRows.length; i++) {
            rowId = availablePageRows[i];
            rowIndex = rowList.indexOf(rowId);

            if(isAllSelected){
                //add the row if it is not added
                if(rowIndex === -1) rowList.push(rowId);
            }
            else{
                //remove the row if it is found in the list
                if(rowIndex !== -1) rowList.splice(rowIndex, 1);
            }
        }

        //update the revised list in state
        setSelectedRows([...rowList])
        if(onSelectedRowsChange) onSelectedRowsChange([...rowList])
    }

    const onRowSelectClick = (rowId)=>{
        let rowList = [...selectedRows];
        let isSelected = isRowSelected(rowId);
        
        if(!isSelected)
            if(fn.compareNumber(enableSelect, 10)){
                rowList = [rowId];
            }
            else{
                rowList.push(rowId)
            }
        else{
          let index = rowList.indexOf(rowId);
          rowList.splice(index, 1);
        }

        // console.log('Selected Rows',rowList)
        setSelectedRows([...rowList])
        if(onSelectedRowsChange) onSelectedRowsChange([...rowList])
    }

    const isRowSelected = (rowId) => {
        let index = selectedRows.indexOf(rowId);
        return (index !== -1);
    }

    const clearAllSelection = () => {
        setSelectedRows([]);
        onPageChange();
    }

    const setSelectedRowsList = (rowIds, isAllSelected) => {
        const revisedRows = Array.isArray(rowIds) ? [...rowIds] : [];

        setSelectedRows(revisedRows);
        setSelecteAll(isAllSelected ? 1 : 0);

        if(onSelectedRowsChange) onSelectedRowsChange(revisedRows);
    }

    const selectedRowsCount = () => {
        return (selectedRows || []).length;
    }

    const getSelectedRowsCS = (sep) => {
        if(!sep) sep = ",";

        return selectedRows.join(sep);
    }

    const returnObj = {
        clearAllSelection,
        selectedRowsCount,
        onRowSelectClick,
        isRowSelected,
        onPageChange,
        onTrackAvailableRows,
        onSelectAllClick,
        isEnableSelect,
        isSelectAll,
        getSelectedRowsCS,
        selectedRows,
        setSelectedRowsList
    }

    return returnObj

}

export default useRowSelector;
